<template>
        <!-- <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"> -->
    <transition name="animation-fade">
        <div v-show="open" class="dialog-model">
            <div class="model-masking"></div>
            <transition name="animation-scale">
                <div v-if="open" style="position:relative;border-radius:5px;overflow:hidden;">
                    <slot></slot>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        open: {
            type: Boolean,
            default: false
        }
    }
}
</script>

